export const PRESELECT_COUNTRY_COOKIE = 'klg.features.QTpreselectCountryExperiment';
